export default {"src":"/_next/static/media/IgIcon.be590434.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};